import { IEventMarketHandicapFromWS } from '@/types/event';
import { BetSelection, Jollywhere } from '@/constants';
import { AbstractMarket } from '@/models/abstractMarket';

export class MarketHandicapItem extends AbstractMarket {
    public handicap: string;
    public jollywhere: Jollywhere;
    public homePrice: string | null;
    public awayPrice: string | null;
    public homeBookmakerId: number | null;
    public awayBookmakerId: number | null;
    public homePriceList: [number, number][] | null;
    public awayPriceList: [number, number][] | null;
    public feedCount: number;
    public marginPerc: string | null;

    constructor(data: IEventMarketHandicapFromWS) {
        super();

        this.setPreviousPrice(BetSelection.HandicapHome, data.price_home_max);
        this.setPreviousPrice(BetSelection.HandicapAway, data.price_away_max);

        this.homePrice = data.price_home_max;
        this.awayPrice = data.price_away_max;
        this.homeBookmakerId = data.price_home_max_site_id;
        this.awayBookmakerId = data.price_away_max_site_id;
        this.homePriceList = data.price_home_list ? JSON.parse(data.price_home_list) : null;
        this.awayPriceList = data.price_away_list ? JSON.parse(data.price_away_list) : null;
        this.handicap = data.handicap;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
        this.jollywhere = data.jollywhere;
    }

    public update(data: IEventMarketHandicapFromWS) {
        this.setPreviousPrice(BetSelection.HandicapHome, this.homePrice);
        this.setPreviousPrice(BetSelection.HandicapAway, this.awayPrice);

        this.homePrice = data.price_home_max;
        this.awayPrice = data.price_away_max;
        this.homeBookmakerId = data.price_home_max_site_id;
        this.awayBookmakerId = data.price_away_max_site_id;
        this.homePriceList = data.price_home_list ? JSON.parse(data.price_home_list) : null;
        this.awayPriceList = data.price_away_list ? JSON.parse(data.price_away_list) : null;
        this.handicap = data.handicap;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
        this.jollywhere = data.jollywhere;
    }
}
